/*
 * Colour swatches on a product card switch the card in place.
 *
 * Every colour is its own product, so a swatch used to be a plain link to
 * another product page: tap "червона" in the catalog and you were taken away
 * from it. Now the card fetches the other colour's card
 * (templates/product.cp-card.liquid) and swaps itself — photo, name, price,
 * sizes and swatches all belong to the new colour, and the size buttons add
 * that colour.
 *
 * The link stays a real link: with a modifier key, a middle click, or when
 * the fetch fails, the browser simply follows it. Cards are prefetched on
 * pointerenter / touchstart so the swap is instant on a tap.
 */
const cache = new Map();

function cardUrl(href) {
  const url = new URL(href, window.location.origin);
  url.searchParams.set('view', 'cp-card');
  return url.toString();
}

function load(href) {
  const key = cardUrl(href);
  if (!cache.has(key)) {
    cache.set(key, fetch(key, { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const card = doc.querySelector('.minimal-card');
        if (!card) throw new Error('no card');
        return card;
      })
      .catch(function (error) { cache.delete(key); throw error; }));
  }
  return cache.get(key);
}

function swatchFrom(target) {
  const a = target.closest && target.closest('.card-swatches a[href]');
  return a && a.closest('.minimal-card') ? a : null;
}

function prefetch(event) {
  const a = swatchFrom(event.target);
  if (a) load(a.href).catch(function () {});
}

document.addEventListener('pointerenter', prefetch, true);
document.addEventListener('touchstart', prefetch, { passive: true, capture: true });

document.addEventListener('click', function (event) {
  const a = swatchFrom(event.target);
  if (!a) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

  const card = a.closest('.minimal-card');
  // The active swatch is the card's own product: nothing to switch to.
  if (a.href.split('?')[0] === (card.querySelector('.minimal-card-link') || {}).href) {
    event.preventDefault();
    return;
  }

  event.preventDefault();
  card.classList.add('is-switching');

  load(a.href)
    .then(function (fresh) {
      const next = document.importNode(fresh, true);
      const hadSwipe = !!card.querySelector('.minimal-card-image-wrapper.has-swipe');
      if (!hadSwipe) {
        const wrap = next.querySelector('.minimal-card-image-wrapper');
        if (wrap) wrap.classList.remove('has-swipe');
        next.querySelectorAll('.minimal-card-dots').forEach(function (n) { n.remove(); });
        const link = next.querySelector('.minimal-card-link');
        if (link) link.removeAttribute('data-cp-hscroll');
      }
      // Already revealed on screen: skip the scroll-in animation.
      if (card.classList.contains('in-view')) next.classList.add('in-view');
      next.classList.add('is-switched');
      card.replaceWith(next);
      const focus = next.querySelector('.card-swatches a');
      if (focus && event.detail === 0) focus.focus({ preventScroll: true });
    })
    .catch(function () {
      window.location.href = a.href;
    });
});
